import { IconDispenser } from 'components/icons/IconDispenser'
import { IconGateway } from 'components/icons/IconGateway'
import { IconMoth } from 'components/icons/IconMoth'
import { IconNodeWithDevices } from 'components/icons/IconNodeWithDevices'
import { IconRepeater } from 'components/icons/IconRepeater'
import { IconStation } from 'components/icons/IconStation'
import { IconTrap } from 'components/icons/IconTrap'
import { translate } from 'i18n/i18n'
import { captureFrontendError } from 'utils/captureFrontendError'
import type { TEquipmentType } from '../../store/serviceCenterStore'

type IconComponent = () => React.JSX.Element

export const EQUIPMENT_TYPES: TEquipmentType[] = ['trap', 'gateway', 'dispenser', 'repeater', 'station']

export const EQUIPMENT_TYPE_ICONS: {
  [K in TEquipmentType]: IconComponent
} = {
  trap: IconTrap,
  gateway: IconGateway,
  dispenser: IconDispenser,
  repeater: IconRepeater,
  station: IconStation,
  external: () => <></>, // TODO: Add external icon
}

export const DEVICEABLE_EQUIPMENTS = ['repeater', 'station']

export const EQUIPMENT_TYPE_INNER_ICONS: {
  [K in TEquipmentType]?: IconComponent
} = {
  trap: IconMoth,
  station: IconNodeWithDevices,
}

export const getEquipmentTypeLabel = (equipmentType: TEquipmentType, plural = false): string => {
  switch (equipmentType) {
    case 'trap':
      return translate.phrases.placeholder(plural ? 'Traps' : 'Trap')

    case 'gateway':
      return translate.phrases.placeholder(plural ? 'Gateways' : 'Gateway')

    case 'dispenser':
      return translate.phrases.placeholder(plural ? 'Dispensers' : 'Dispenser')

    case 'repeater':
      return translate.phrases.placeholder(plural ? 'Repeaters' : 'Repeater')

    case 'station':
      return translate.phrases.placeholder(plural ? 'Stations' : 'Station')

    default: {
      captureFrontendError(`Equipment type "${equipmentType}" has not been implemented`)

      return equipmentType
    }
  }
}
